import Teacher1 from '../assets/Teacher1.png';
import Teacher2 from '../assets/Teacher2.png';

export const TEACHERS = [
  {
    imageSrc: Teacher1,
    name: 'Ricardo Savluchinske',
    description:
      "Graduated in Hatha Yoga, I've dedicated my life to guide people to be the best of them phisicly, mindly and spiritualy. Come join me in this amazing path called Yoga.",
    styles: ['Hatha Yoga'],
    days: ['Monday', 'Wendnesday'],
    hours: ['7:00', '8:00'],
  },
  {
    imageSrc: Teacher2,
    name: 'Aline Furtado',
    description:
      "Graduated Vinyasa Flow Yoga, I've dedicated my life to guide people to be the best of them phisicly, mindly and spiritualy. Come join me in this amazing path called Yoga.",
    styles: ['Vinyasa Flow', 'Yin Yoga'],
    days: ['Tuesday', 'Thursday', ' Friday'],
    hours: ['18:00', '19:00'],
  },
];
